import { render, staticRenderFns } from "./PieForResult.vue?vue&type=template&id=34e8d0eb&scoped=true&"
import script from "./PieForResult.vue?vue&type=script&lang=js&"
export * from "./PieForResult.vue?vue&type=script&lang=js&"
import style0 from "./PieForResult.vue?vue&type=style&index=0&id=34e8d0eb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8d0eb",
  null
  
)

export default component.exports